import generated from './api-endpoints';

export const endpoints = generated;
